var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3C1.86193 3 1.75 3.11193 1.75 3.25V14.25C1.75 14.3881 1.86193 14.5 2 14.5H14C14.1381 14.5 14.25 14.3881 14.25 14.25V3.25C14.25 3.11193 14.1381 3 14 3H2ZM0.25 3.25C0.25 2.2835 1.0335 1.5 2 1.5H14C14.9665 1.5 15.75 2.2835 15.75 3.25V14.25C15.75 15.2165 14.9665 16 14 16H2C1.0335 16 0.25 15.2165 0.25 14.25V3.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C12.4142 0 12.75 0.335786 12.75 0.75V3.75C12.75 4.16421 12.4142 4.5 12 4.5C11.5858 4.5 11.25 4.16421 11.25 3.75V0.75C11.25 0.335786 11.5858 0 12 0Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C4.41421 0 4.75 0.335786 4.75 0.75V3.75C4.75 4.16421 4.41421 4.5 4 4.5C3.58579 4.5 3.25 4.16421 3.25 3.75V0.75C3.25 0.335786 3.58579 0 4 0Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23735 10.1302H8.45189V10.0133C8.45189 9.50879 8.66001 9.26651 9.09052 9.00998C9.63792 8.68789 10 8.27458 10 7.59335C10 6.55867 9.14754 6 7.97292 6C6.90093 6 6.01711 6.53302 6 7.73017H7.31148C7.32003 7.33397 7.62224 7.09454 7.96151 7.09454C8.29793 7.09454 8.56593 7.31971 8.56593 7.65891C8.56593 8.00665 8.29508 8.22898 7.9387 8.45701C7.48539 8.74774 7.2402 9.04703 7.23735 10.0133V10.1302ZM7.86743 12C8.25802 12 8.60299 11.6694 8.6087 11.2589C8.60299 10.8542 8.25802 10.5264 7.86743 10.5264C7.45688 10.5264 7.12046 10.8542 7.12616 11.2589C7.12046 11.6694 7.45688 12 7.86743 12Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustom);
export default __webpack_public_path__ + "static/media/custom.140b843f.svg";
export { ForwardRef as ReactComponent };